module.exports = __webpack_public_path__ + "1740f16a897f4f90357f8c2fa1fca3ed.pdf";